import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"16px","margin-bottom":"16px"} }
const _hoisted_3 = { class: "form-item-content" }
const _hoisted_4 = { class: "form-item-content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 3 }

import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { RechargeOrderListRequest } from "@/api/models/recharge_order/RechargeOrderListRequest";
import { RechargeOrder } from "@/api/models/recharge_order/RechargeOrder";
import { RechargeOrderService } from "@/api/services/RechargeOrderService";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRecharge',
  setup(__props) {

const total = ref<number>(0);

const listRequest = reactive<RechargeOrderListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const rechargeOrderList = ref<RechargeOrder[]>([]);

const handleList = async () => {
  const res = await RechargeOrderService.ListAll(listRequest);
  if (res.code === 0) {
    rechargeOrderList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.status = undefined;
  handleList();
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const submitDelete = async (record: RechargeOrder) => {
  const res = await RechargeOrderService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: RechargeOrder) => {
  const res = await RechargeOrderService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "用户OpenId",
    dataIndex: "user_open_id",
    align: "center",
  },
  {
    title: "充值金额",
    dataIndex: "recharge_amount",
    align: "center",
  },
  {
    title: "赠送金额",
    dataIndex: "bonus_amount",
    align: "center",
  },
  {
    title: "支付状态",
    dataIndex: "status",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "更新时间",
    dataIndex: "update_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, { layout: "inline" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "搜索内容：", -1)),
                _createVNode(_component_a_input, {
                  placeholder: "用户OpenId",
                  value: listRequest.content,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((listRequest.content) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "支付状态：", -1)),
                _createVNode(_component_a_select, {
                  style: {"width":"200px"},
                  value: listRequest.status,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((listRequest.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("未支付")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("已支付")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 3 }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("支付失败")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: handleList
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("搜索")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: resetSearch
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("重置 ")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_table, {
      columns: columns,
      "data-source": rechargeOrderList.value,
      pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
      bordered: ""
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'update_at')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(dayjs)(record.update_at).format("YYYY-MM-DD HH:mm:ss")), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (record.status === 1)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "yellow"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("未支付")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.status === 2)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "green"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("已支付")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.status === 3)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 2,
                    color: "red"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("支付失败")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : (column.dataIndex === 'is_delete')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (record.is_delete === 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "green"
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (record.is_delete === 2)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      color: "red"
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : (column.dataIndex === 'create_at')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
              : (column.dataIndex === 'operator')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createVNode(_component_a_button, {
                      onClick: ($event: any) => (submitDelete(record)),
                      type: "primary",
                      style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("删除 ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_a_button, {
                      onClick: ($event: any) => (submitDrop(record)),
                      type: "primary",
                      style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("彻底删除 ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "pagination"])
  ]))
}
}

})